import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { KillswitchFeature } from 'src/constants/payments-ops/enums'
import type { KillswitchState } from 'src/interfaces/usBankKillswitch'
import { getKillswitchFlags } from 'src/selectors/usBankKillswitch'
import { deriveKillswitchState } from 'src/utils/paymentsOps/killswitchState'

interface KillswitchStates {
  payments: KillswitchState
  webhooks: KillswitchState
}

/** Both killswitches, derived once from the stored flag rows. Stable while the rows are. */
export const useKillswitchStates = (): KillswitchStates => {
  const flags = useSelector(getKillswitchFlags)

  return useMemo(() => {
    return {
      payments: deriveKillswitchState(flags[KillswitchFeature.PaymentProcessing]),
      webhooks: deriveKillswitchState(flags[KillswitchFeature.Webhooks]),
    }
  }, [flags])
}
